module.exports = __webpack_public_path__ + "static/media/coldstorage3.1f4027e5.jpg";